import { useEffect } from 'react';
import { Analytics } from '@trello/atlassian-analytics';
import { getDefaultAnalyticsContext } from 'app/src/defaultAnalyticsContext';
import { useMemberContextData } from './useMemberContextData';
import { useOrgContextData } from './useOrgContextData';
import { useWorkspace } from '@trello/workspaces';

export const useAnalyticsContext = () => {
  const { idWorkspace } = useWorkspace();
  const memberData = useMemberContextData();
  const orgData = useOrgContextData(idWorkspace);

  useEffect(() => {
    Analytics.clearContext('organization');
    Analytics.clearContext('workspace');
  }, [idWorkspace]);

  useEffect(() => {
    const newContext = getDefaultAnalyticsContext({
      member: memberData?.member,
      organization: orgData?.organization,
      workspace: orgData?.organization, //we should use orgData until a workspace exists to query with GraphQL
    });
    Analytics.setContext(newContext);
    // eslint-disable-next-line @trello/exhaustive-deps
  }, [memberData?.member?.id, orgData?.organization?.id]);
};
